import axios from 'axios'
import { ANALYSIS_DATA_PROJECTION, validateAnalysisDataProjection } from '@/utils/analysisDataStatus'

const API_BASE = process.env.VUE_APP_API_URL || '/api'

const client = axios.create({
  baseURL: API_BASE,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
})

client.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
)

function unwrapBusinessPayload(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value || {}
  if (value.machine_payload && typeof value.machine_payload === 'object') return value.machine_payload
  if (value.payload && typeof value.payload === 'object') return value.payload
  if (value.data && typeof value.data === 'object' && !Array.isArray(value.data)) return value.data
  return value
}

export const firstBookP0Api = {
  getCurrent: () => client.get('/first-book/current'),
  getContract: () => client.get('/first-book/p0/contract'),
  getSemanticsContract: () => client.get('/first-book/semantics/contract'),
  async getSemanticsCurrent() {
    const payload = await client.get('/first-book/semantics/current', {
      params: { projection: 'semantics_only', _: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
      timeout: 30000
    })
    return unwrapBusinessPayload(payload)
  },
  async getAnalysisDataStatus() {
    const payload = await client.get('/first-book/semantics/current', {
      params: { projection: ANALYSIS_DATA_PROJECTION, _: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
      timeout: 15000
    })
    return validateAnalysisDataProjection(payload, 'first_book')
  },
  getMigrationPreview: () => client.get('/first-book/semantics/migration-preview'),
  resolveBatch: (entries, zone) => client.post('/first-book/p0/resolve-batch', { entries, zone }),
  previewBatch: (items, reason) => client.post('/first-book/p0/batch-preview', { items, reason }),
  confirmBatch: (batchDiffId) => client.post('/first-book/p0/batch-confirm', { batch_diff_id: batchDiffId }),
  generateDiff: (data) => client.post('/first-book/diff', data),
  confirmChange: (diffId) => client.post('/first-book/confirm', { diff_id: diffId, confirmed: true }),
  getSuggestions: (keyword, limit = 20) => client.get('/stock/suggestions', { params: { q: keyword, limit } }),
  getPopularStocks: (keyword = '') => client.get('/first-book/popular-stocks', { params: { keyword, limit: 50 } }),
  resolveName: (tsCode) => client.get(`/first-book/resolve-name/${tsCode}`),

  getDailyReviewPlan: (params = {}) => client.get('/first-book/daily-review/plan', { params }),
  listDailyReviewChangeSets: (limit = 20) => client.get('/first-book/daily-review/change-sets', { params: { limit } }),
  previewDailyReviewChangeSet: (data) => client.post('/first-book/daily-review/change-sets/preview', data),
  getDailyReviewChangeSet: (changeSetId) => client.get(`/first-book/daily-review/change-sets/${encodeURIComponent(changeSetId)}`),
  confirmDailyReviewChangeSet: (changeSetId, data) => client.post(`/first-book/daily-review/change-sets/${encodeURIComponent(changeSetId)}/confirm`, data),
  readbackDailyReviewChangeSet: (changeSetId) => client.get(`/first-book/daily-review/change-sets/${encodeURIComponent(changeSetId)}/readback`)
}

export function firstBookErrorMessage(error, fallback = '操作失败') {
  const detail = error && error.response && error.response.data && error.response.data.detail
  if (typeof detail === 'string') return detail
  if (detail && typeof detail === 'object') {
    if (detail.message) return detail.message
    if (Array.isArray(detail.errors) && detail.errors.length > 0) return detail.errors.join('；')
  }
  return (error && error.message) || fallback
}
